if (!customElements.get('ib-home-blog')) {
  class IronBackBlog extends HTMLElement {
    connectedCallback() {
      if (this.abort) return;
      this.track = this.querySelector('.ib-home-blog-track');
      this.controls = this.querySelector('.ib-home-blog-controls');
      if (!this.track || !this.controls) return;
      this.buttons = [...this.controls.querySelectorAll('button')];
      this.abort = new AbortController();
      const options = { signal: this.abort.signal };
      this.track.addEventListener('scroll', () => this.schedule(), { ...options, passive: true });
      this.buttons.forEach(button => button.addEventListener('click', () => this.move(Number(button.dataset.direction)), options));
      this.track.addEventListener('focusin', event => {
        const slide = event.target.closest('.ib-home-blog-slide');
        if (!slide) return;
        const left = slide.offsetLeft;
        const right = left + slide.offsetWidth;
        if (left < this.track.scrollLeft || right > this.track.scrollLeft + this.track.clientWidth) {
          this.track.scrollTo({ left: Math.min(left, this.maximum()), behavior: 'auto' });
        }
      }, options);
      this.track.addEventListener('pointerdown', event => {
        this.start = { x: event.clientX, y: event.clientY };
        this.dragged = false;
      }, { ...options, passive: true });
      this.track.addEventListener('pointermove', event => {
        if (!this.start) return;
        const x = Math.abs(event.clientX - this.start.x);
        const y = Math.abs(event.clientY - this.start.y);
        if (x > 8 && x > y) this.dragged = true;
      }, { ...options, passive: true });
      this.track.addEventListener('pointerup', () => { this.start = null; }, options);
      this.track.addEventListener('pointercancel', () => { this.start = null; }, options);
      this.track.addEventListener('click', event => {
        if (this.dragged) {
          event.preventDefault();
          event.stopPropagation();
          this.dragged = false;
        }
      }, { ...options, capture: true });
      this.observer = new ResizeObserver(() => this.schedule());
      this.observer.observe(this.track);
      this.schedule();
    }
    disconnectedCallback() {
      this.abort?.abort();
      this.observer?.disconnect();
      cancelAnimationFrame(this.frame);
      this.abort = null;
      this.start = null;
    }
    maximum() {
      return Math.max(0, this.track.scrollWidth - this.track.clientWidth);
    }
    schedule() {
      cancelAnimationFrame(this.frame);
      this.frame = requestAnimationFrame(() => {
        const maximum = this.maximum();
        this.controls.hidden = maximum <= 2;
        this.buttons[0].disabled = this.track.scrollLeft <= 2;
        this.buttons[1].disabled = this.track.scrollLeft >= maximum - 2;
      });
    }
    move(direction) {
      const maximum = this.maximum();
      const positions = [...new Set([...this.track.children].map(slide => Math.min(slide.offsetLeft, maximum)))];
      const current = this.track.scrollLeft;
      const target = direction > 0
        ? positions.find(position => position > current + 2) ?? maximum
        : positions.slice().reverse().find(position => position < current - 2) ?? 0;
      const reducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
      this.track.scrollTo({ left: target, behavior: reducedMotion ? 'auto' : 'smooth' });
    }
  }
  customElements.define('ib-home-blog', IronBackBlog);
}
